/** PI */

// export const project_information_pdf = 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/project-manual-02112019.pdf'
// export const project_information_video = ''
// export const project_information_images = [
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/1.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/2.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/3.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/4.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/5.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/6.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/7.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/8.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/9.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/10.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/11.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/12.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/13.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/14.png' },
//   { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/project-information-user-manual/15.png' },
// ]

export const pi_cost_planning_pdf = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/PDF/proj-info-manual.pdf'
export const pi_cost_planning_video = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/VIEDO/Cost-Planning.mp4'
export const pi_cost_planning_images = [
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-01.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-02.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-03.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-04.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-05.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-06.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-07.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-08.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/cost-planning/JPG/b-09.jpg' },
]

export const pi_revenue_planning_pdf = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/PDF/proj-info-manual.pdf'
export const pi_revenue_planning_video = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/VIEDO/Revenue-Planning-b.mp4'
export const pi_revenue_planning_images = [
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-01.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-02.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-03.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-04.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-05.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-06.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-07.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-08.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-09.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-10.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-11.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-12.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-13.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-14.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-15.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-16.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-17.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/revenue-allocation/JPG/c-18.jpg' },
]

export const pi_overview_pdf = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/PDF/proj-info-manual.pdf'
export const pi_overview_video = ''
export const pi_overview_images = [
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-01.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-02.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-03.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-04.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-05.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-06.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-07.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-08.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-09.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-10.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-11.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-12.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-13.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-14.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-15.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-16.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-17.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-18.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-19.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-20.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-21.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-22.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-23.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-24.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-25.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-26.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/JPG/a-27.jpg' },
]

/** TIMESHEET */

export const timesheet_pdf = 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/Timesheet-Manual.pdf'
export const timesheet_images = [
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/1.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/2.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/3.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/4.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/5.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/6.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/7.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/8.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/9.jpg' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/Timesheet+User+Mannual/10.jpg' },
]

/** EFFICIENCY */

export const efficiency_pdf = 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/efficiency-manual-3.pdf'
export const efficiency_images = [
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/1.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/2.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/3.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/4.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/5.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/6.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/7.png' },
  { src: 'https://s3-ap-southeast-1.amazonaws.com/kawari-public/efficiency-resource-manual/8.png' },
]

/** PROFIT SHEET */

export const project_profit_sheet_pdf = 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/Kawari-PPSReport.pdf'
export const project_profit_sheet_images = [
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/1.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/2.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/3.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/4.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/5.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/6.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/7.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/8.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/9.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/10.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/11.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/12.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/13.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/14.jpg' },
]

export const project_profit_sheet_report_pdf = 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/Kawari-ppsDashboard.pdf'
export const project_profit_sheet_report_images = [
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/dashboard-1.jpg' },
  { src: 'https://kawari-public.s3-ap-southeast-1.amazonaws.com/Project+Profit+Sheet+Mannual/dashboard-2.jpg' },
]

/** SALE PRODUCT */

export const sale_product_pdf = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/sale-product/PDF/sale-product.pdf'
export const sale_product_video = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/VIEDO/sale-prod-master.mp4'
export const sale_product_images = [
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/sale-product/JPG/e-01.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/sale-product/JPG/e-02.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/sale-product/JPG/e-03.jpg' },
]

/** EMPLOYEE */

export const employee_pdf = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/employee-master/PDF/emp-master.pdf'
export const employee_video = 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/project-information/VIEDO/Intro-EmpMaster.mp4'
export const employee_images = [
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/employee-master/JPG/d-01.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/employee-master/JPG/d-02.jpg' },
  { src: 'https://kawari-assets.s3-ap-southeast-1.amazonaws.com/employee-master/JPG/d-03.jpg' },
]



// WEBPACK FOOTER //
// ./src/static/images/manual/index.js